var InterpolationType;
(function (InterpolationType) {
    InterpolationType[InterpolationType["NEAREST"] = 0] = "NEAREST";
    InterpolationType[InterpolationType["LINEAR"] = 1] = "LINEAR";
    InterpolationType[InterpolationType["FAST_LINEAR"] = 2] = "FAST_LINEAR";
})(InterpolationType || (InterpolationType = {}));
export default InterpolationType;
